import { App } from 'vue';

import GiftCollectionDisplay from '@/components/Cart/FreeGift/GiftCollectionDisplay.vue';

import type { InitializationState } from './index';
import { giftCollectionDisplayMountSelector } from './index';
import { initializeComponent } from './shared';

export const initGiftCollectionDisplay = async (
  waitForCartUpdate = false,
  mountedApps: Map<string, App>,
  initializationState: InitializationState
): Promise<void> => {
  await initializeComponent({
    containerId: 'gift-collection-display',
    mountSelector: giftCollectionDisplayMountSelector,
    component: GiftCollectionDisplay,
    state: initializationState.giftCollectionDisplay,
    mountedApps,
    waitForCartUpdate,
    extractProps: (container) => {
      const dataset = container.dataset;
      const collectionHandle = dataset.collectionHandle;
      if (!collectionHandle) {
        console.warn('No collection handle provided for gift display');
        return null;
      }

      return {
        collectionHandle,
        giftThreshold: Number(dataset.giftThreshold || 0),
        shippingThreshold: Number(dataset.shippingThreshold || 0),
        maxProducts: Number(dataset.maxProducts || 3),
        isMainCart: !!container.closest('.maincart')
      };
    }
  });
};
